import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { ChangeSourceType } from '@ag-common-lib/lib/lists/change-logs/change-source-type.enum';

@Injectable({
  providedIn: 'root',
})
export class ChangeSourceTypeService {
  defaultSource: ChangeSourceType;
  private _sourceTypeSig: WritableSignal<ChangeSourceType> = signal<ChangeSourceType>(null);

  setSourceType(sourceType: ChangeSourceType, isDefaultSource = false) {
    if (isDefaultSource) {
      this.defaultSource = sourceType;
    }
    this._sourceTypeSig.set(sourceType);
    console.log('%cChangeSourceTypeService sourceType set as ', 'color: green', this._sourceTypeSig());
  }

  /* @Usage in html: My signal value is: {{ sourceType() }} */
  get sourceType(): Signal<ChangeSourceType> {
    return this._sourceTypeSig.asReadonly();
  }
}
